export enum Errors {
  ACCEPT_TABLE_INVITE = "Accept invite to table flow",
  ADBLOCK_DETECTION = "AdBlock detection failed",
  ASSIGN_TABLES_ALL_ATTENDEE_INVITE = "Assign Table Event Attendee Invite",
  ASSIGN_TABLES_ALL_ATTENDEE_MOVE = "Assign Table Event Attendee Move",
  COMPANY_SAVE = "Company Save",
  COMPANY_TIMEZONE = "Company Timezone Update",
  DISABLE_VPN_CHECK_UPDATE = "Company Settings - Disable VPN Check",
  EMBED_CONTENT_CREATE_MUTATION = "Create Embed Content",
  EMBED_CONTENT_DELETE_MUTATION = "Delete Embed Content",
  EMBED_CONTENT_QUERY = "Get Embed Content",
  EMBED_CONTENT_SUBSCRIPTION = "Embed Content Subscription",
  EVENT_ANALYTICS_EMBED_URL = "Failed to fetch event analytics embed URL",
  EVENT_CONTENT_CHANGED_SUBSCRIPTION = "Event Content Updates Subscription",
  EVENT_CONTENT_DELETED_SUBSCRIPTION = "Event Content Deletions Subscription",
  EVENT_CONTENT_QUERY = "Get Event Content",
  EVENT_FLOOR_CONTENT_CHANGED_SUBSCRIPTION = "Event Content Floor Updates Subscription",
  EVENT_FLOOR_CONTENT_DELETED_SUBSCRIPTION = "Event Content Floor Deletions Subscription",
  EVENT_FLOOR_CONTENT_QUERY = "Get Event Floor Content",
  EVENT_TABLE_SETTINGS = "Get Event Table Settings",
  EVENT_TABLE_SETTINGS_SAVE = "Update Event Table Settings",
  FB_HANDLE_INVITED = "Firebase handle invited",
  FETCH_VPN_CHECK_DISABLED = "Fetch check vpn disabled",
  FOCUSED_SCREEN_SUBSCRIBE = "Focused screen subscribe",
  GET_ATTENDEE_LIST = "Get Attendee List Error",
  GET_CURRENCY_SYMBOL = "Get Currency Symbol Error",
  GET_DEPLOYED_VERSION = "Get Latest Version",
  GET_PAST_EVENTS = "Get Past Events Error",
  GET_USER_MEDIA = "Get User Media",
  GRAPHQL_NETWORK_ERROR = "GraphQL Network Error",
  GRAPHQL_RETRY_MAX = "Graphql: Max retry attempts exceeded",
  GUEST_EXPERIENCE_SURVEY_GET_EVENT_RATING = "Guest Experience Survey Get Event Rating",
  GUEST_EXPERIENCE_SURVEY_MUTATE_EVENT_RATING = "Guest Experience Survey Mutate Event Rating",
  HOST_ONBOARDING_FIRST_EVENT = "Host Onboarding - First Event Page",
  MEDIA_DEVICE_ENUM = "Media Device Enumeration",
  OT_CONNECT_SESSION = "OpenTok Connect Session",
  OT_GET_PREFERRED_SETTINGS = "OpenTok could not get preferred frame rate and resolution",
  OT_ROOM_DESYNC = "OpenTok User In Stream Is Not At Table",
  OT_SCREEN_PUBLISH = "OpenTok Screen Publish",
  OT_SCREEN_SESSION_PUBLISH = "OpenTok Screen Session Publish",
  OT_SESSION_RECONNECT_ATTEMPTS_EXCEEDED = "OpenTok Reconnect Attempts Exceeded",
  OT_SIGNAL = "OpenTok Signal",
  OT_STATS = "OpenTok Subscriber getStats",
  OT_SUBSCRIBE_STREAM = "OpenTok Subscribe Stream",
  OT_VIDEO_BACKGROUND_PUBLISH = "OpenTok Video Background Publish",
  OT_VIDEO_BACKGROUND_SESSION_PUBLISH = "OpenTok Video Background Session Publish",
  OT_VIDEO_EFFECTS_PACKAGE_LOAD_ERROR = "OpenTok video effects package failed to load",
  OT_VIDEO_PUBLISH = "OpenTok Video Publish",
  OT_VIDEO_SESSION_PUBLISH = "OpenTok Video Session Publish",
  PASSWORD_RESET_FAILED = "Password reset error",
  POLLS_SUBSCRIPTION_ERROR = "Error with polls subscription",
  PRESENTATION_MODE_GET_ATTENDEE_ON_STAGE = "Presentation Mode Get Attendee OnStage",
  SEND_ATTENDEE_INVITE = "Send Attendee Invite",
  SET_FOCUSED_SCREEN = "Set Focused Screen",
  SHUFFLE_START = "Shuffle start - unable to set document in Firestore",
  SUBSCRIPTION_CANCEL = "Cancel Subscription",
  TEST = "only used for unit testing",
  UNEXPECTED_FACEBOOK_SSO_ERROR = "Unexpected error in Facebook SSO authentication",
  UNEXPECTED_GOOGLE_SSO_ERROR = "Unexpected error in Google SSO authentication",
  UNEXPECTED_LINKEDIN_SSO_ERROR = "Unexpected error in Linkedin SSO authentication",
  UNEXPECTED_MS_SSO_ERROR = "Unexpected error in MS SSO authentication",
  UNHANDLED_ERROR = "Unhandled Error",
  UNHANDLED_EVENT_CHECK = "Unhandled Event Check",
  UPDATE_LOGIN_OPTIONS = "Update Login Options",
  UNREACHABLE_THIRD_PARTY_SERVICE = "Unreachable endpoint",
  VPN_DETECTION = "VPN detection failed",
  VPN_QUOTA_LIMIT_REACHED = "VPN quota limit reached",
}
